import React from "react";
import { Config, MetadataDict } from "../types";
import Select from "react-select";
import { defaultSettings } from "./App";
import * as resourceInfo from "../resourceInfo.json";

export default function UI({
  config,
  setConfig,
  metadataDict,
}: {
  config: Config;
  setConfig: React.Dispatch<React.SetStateAction<Config>>;
  metadataDict: MetadataDict;
}) {
  const dropDownOptions = [
    // { value: "cortex", label: "Cortex vs non-cortex" },
    { value: "resource", label: "Resource ids" },
    { value: "id", label: "Brain regions" },
  ];

  return (
    <div className="UI-layout">
      <>
        <div
          style={{ display: "flex", flexDirection: "column", justifyContent: "space-between" }}
          className="footer-container"
        >
          <div>
            <small>Color by:</small>
            <Select
              options={dropDownOptions}
              onChange={(selected) => {
                if (selected) {
                  setConfig({ ...config, colormap: selected.value, filtexIdx: [] });
                }
              }}
              value={config.colormap === "resource" ? dropDownOptions[0] : dropDownOptions[1]}
            />
          </div>
          <div>
            <small>Disabled brain opacity</small>
            <br />
            <input
              type="range"
              value={config.disabledPointOpacity}
              min={0}
              max={1000}
              onChange={(e) => {
                setConfig({ ...config, disabledPointOpacity: parseInt(e.target.value) });
              }}
            />
          </div>
          <div>
            <small>Brain point size</small>
            <br />
            <input
              type="range"
              value={config.brainPointSize}
              min={0}
              max={2000}
              onChange={(e) => {
                setConfig({ ...config, brainPointSize: parseInt(e.target.value) });
              }}
            />
          </div>
          <div>
            <small>Disabled cube opacity</small>
            <br />
            <input
              type="range"
              value={config.disabledCubeOpacity}
              min={0}
              max={1000}
              onChange={(e) => {
                setConfig({ ...config, disabledCubeOpacity: parseInt(e.target.value) });
              }}
            />
          </div>
          <div style={{ display: "flex" }}>
            <button style={{ marginLeft: "10px" }} onClick={() => setConfig({ ...defaultSettings })}>
              Reset all settings
            </button>
          </div>
        </div>

        <div className="footer-container">
          <h4>Show resource</h4>
          {
            <div
              className="regions-choose"
              style={{ display: "flex", flexDirection: "column", overflowY: "scroll", maxHeight: "15vh" }}
            >
              {Array.from({ length: 12 }, (x, i) => i).map((i) => {
                const resourceId = (i + 1).toString() as keyof typeof resourceInfo;
                return (
                  <div key={"resource" + resourceId + "ui checkbox"}>
                    <input
                      type="checkbox"
                      checked={config.selectedResource?.toString() === resourceId}
                      onChange={(e) => {
                        setConfig({
                          ...config,
                          selectedResource: e.target.checked ? parseInt(resourceId) : undefined,
                          selectedRegion: undefined,
                        });
                      }}
                    />{" "}
                    Resource {resourceId} ({resourceInfo[resourceId].name})
                  </div>
                );
              })}
            </div>
          }
        </div>
      </>
    </div>
  );
}
